import {inject, Injectable} from '@angular/core';
import {BaforService} from "./bafor.service";
import i18next from "i18next";
import {Bafor} from "../model/bafor";

@Injectable({providedIn: 'root'})
export class PersonDisplayService {

    private readonly baforService = inject(BaforService);

    displayName(personName: string, personId: string): string {
        const bafor = this.baforService.parse(personId);
        if (bafor) {
            const referenzId = this.baforService.getReferenzId(bafor);
            const displayName = personName ? personName : this.getDefaultName(bafor);
            return `${displayName ?? i18next.t('nachricht.person-unknown.default')} (${referenzId})`;
        }
        return personName ? personName : i18next.t('nachricht.person-unknown.default');
    }

    private getDefaultName(bafor: Bafor): string | null {
        if (!bafor) return null;

        switch (true) {
            case this.baforService.isStepPerson(bafor):
                return i18next.t('nachricht.person-unknown.stepPerson');
            case this.baforService.isStepBetrieb(bafor):
                return i18next.t('nachricht.person-unknown.stepBetrieb');
            case this.baforService.isUbvonlineBevollmaechtigter(bafor):
                return i18next.t('nachricht.person-unknown.ubvonlineBevollmaechtigter');
            case this.baforService.isKiwiKindergeldfall(bafor):
                return i18next.t('nachricht.person-unknown.kiwiKindergeldberechtigter');
            default:
                return null;
        }
    }

}